import { Box } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import PageTitle from "../base/PageTitle";
import AddEditTile from "../views/Tile/AddEditTile";

interface Props {}

const TileFormPage: React.FC<Props> = (props) => {
  const { id } = useParams();

  return (
    <Box>
      <PageTitle title={!!id ? `Edit Dashboard` : "Add New Dashboard"} />
      <AddEditTile id={+id!} tileType="dashboard" />
    </Box>
  );
};

export default TileFormPage;
